module.exports = __webpack_public_path__ + "img/icon4.60e3763.png";